export default __webpack_public_path__ + "static/media/s7.d7c23fc0.jpg";